import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAdminData, addStore, updateStore } from '../store/adminSlice';
import { PW_Stores_API, PW_Store_Save_API } from '../Server/ApiV2';
import Spinner from './Spinner';

export default function Stores() {
  const dispatch = useDispatch();
  const { stores } = useSelector(s => s.admin);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const res = await PW_Stores_API();
      if (cancelled) return;
      if (res?.data?.success) dispatch(setAdminData({ stores: res.data.data }));
      setPageLoading(false);
    })();
    return () => { cancelled = true; };
  }, [dispatch]);
  const [showAdd, setShowAdd] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ name: '', code: '', location: '', city: '', status: 'Active' });

  const resetForm = () => setForm({ name: '', code: '', location: '', city: '', status: 'Active' });

  const handleAdd = () => {
    if (!form.name.trim() || !form.code.trim()) return;
    const id = `STR-${String(stores.length + 1).padStart(3, '0')}`;
    const storeData = { ...form, id, createdAt: new Date().toISOString().split('T')[0] };
    dispatch(addStore(storeData));
    PW_Store_Save_API(storeData).catch(err => console.error('[Stores] Save failed:', err));
    resetForm();
    setShowAdd(false);
  };

  const handleEdit = (store) => {
    setEditingId(store.id);
    setForm({ name: store.name, code: store.code, location: store.location || '', city: store.city || '', status: store.status });
  };

  const handleUpdate = () => {
    const updateData = { id: editingId, ...form };
    dispatch(updateStore(updateData));
    PW_Store_Save_API(updateData).catch(err => console.error('[Stores] Update failed:', err));
    setEditingId(null);
    resetForm();
  };

  if (pageLoading) return <div className="page-loading"><Spinner /></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h2>Stores</h2>
          <div className="page-header-sub">Manage store locations</div>
        </div>
        <button className="btn btn-gold" onClick={() => { resetForm(); setShowAdd(true); setEditingId(null); }}>+ Add Store</button>
      </div>

      {(showAdd || editingId) && (
        <div className="card mb-24">
          <div className="card-title gold">{editingId ? 'Edit Store' : 'New Store'}</div>
          <div className="card-body">
            <div className="form-row mb-16">
              <div className="form-group">
                <label className="form-label">Store Name</label>
                <input className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">Store Code</label>
                <input className="form-input" value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} />
              </div>
            </div>
            <div className="form-row mb-16">
              <div className="form-group">
                <label className="form-label">Location</label>
                <input className="form-input" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} />
              </div>
              <div className="form-group">
                <label className="form-label">City</label>
                <input className="form-input" value={form.city} onChange={e => setForm({ ...form, city: e.target.value })} />
              </div>
            </div>
            {editingId && (
              <div className="form-group mb-16">
                <label className="form-label">Status</label>
                <select className="form-select" style={{ width: 200 }} value={form.status} onChange={e => setForm({ ...form, status: e.target.value })}>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            )}
            <div style={{ display: 'flex', gap: 8 }}>
              <button className="btn btn-success" onClick={editingId ? handleUpdate : handleAdd}
                disabled={!form.name.trim() || !form.code.trim()}>
                {editingId ? 'Update' : 'Create'} Store
              </button>
              <button className="btn btn-secondary" onClick={() => { setShowAdd(false); setEditingId(null); resetForm(); }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-title">
          Stores
          <span style={{ marginLeft: 'auto', fontSize: 12, color: '#6b6b80' }}>{stores.length} stores</span>
        </div>
        <div className="card-body" style={{ padding: 0 }}>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Code</th>
                  <th>Location</th>
                  <th>City</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {stores.map(s => (
                  <tr key={s.id}>
                    <td className="text-sm text-muted">{s.id}</td>
                    <td className="fw-600">{s.name}</td>
                    <td><span className="chip chip-blue">{s.code}</span></td>
                    <td>{s.location}</td>
                    <td>{s.city}</td>
                    <td><span className={s.status === 'Active' ? 'status-active' : 'status-inactive'}>{s.status}</span></td>
                    <td className="text-sm text-muted">{s.createdAt}</td>
                    <td>
                      <button className="btn btn-outline btn-sm" onClick={() => handleEdit(s)}>Edit</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
